module.exports = __webpack_public_path__ + "img/icon-error.7b931519.svg";